module.exports = "/images/shop_a_ranger_v2.jpg?c79bea892d5fd0abbf626b87b2a2eeda";